(function () {
  // Initialize Smartsupp stub immediately so other scripts can call it without errors
  window._smartsupp = window._smartsupp || {};
  window._smartsupp.key = '043dfa8c63561365ab11f12285179acb9270a217';
  if (!window.smartsupp) {
    const o = (window.smartsupp = function () {
      o._.push(arguments);
    });
    o._ = [];
  }

  const SMARTSUPP_BLOCKING_OVERLAY_SELECTOR =
    '.drawer, .product-popup, product-modal-gallery, dialog, [role="dialog"][aria-modal="true"]';
  const SMARTSUPP_SCROLL_REVEAL_DELAY = 500;
  const observedSmartsuppOverlays = new WeakSet();
  let smartsuppHidden = false;
  let smartsuppHiddenForScroll = false;
  let smartsuppScrollEndTimer;
  let smartsuppVisibilityFrame;

  const isSmartsuppBlockingOverlayOpen = (overlay) => {
    if (overlay.matches('.drawer')) {
      return overlay.classList.contains('drawer--opened') || overlay.style.display === 'flex';
    }

    if (overlay.matches('.product-popup')) {
      return overlay.classList.contains('product-popup--open') || overlay.style.display === 'flex';
    }

    if (overlay.matches('product-modal-gallery')) {
      return overlay.style.display === 'block';
    }

    if (overlay.matches('dialog')) {
      return overlay.hasAttribute('open');
    }

    if (overlay.hidden || overlay.getAttribute('aria-hidden') === 'true') return false;

    const styles = window.getComputedStyle(overlay);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && overlay.getClientRects().length > 0;
  };

  const syncSmartsuppVisibility = () => {
    const hasOpenOverlay = Array.from(document.querySelectorAll(SMARTSUPP_BLOCKING_OVERLAY_SELECTOR)).some(
      isSmartsuppBlockingOverlayOpen
    );
    const shouldHide = smartsuppHiddenForScroll || hasOpenOverlay;
    const widgetContainer = document.querySelector('#smartsupp-widget-container');

    if (widgetContainer) {
      if (shouldHide) {
        widgetContainer.style.setProperty('display', 'none', 'important');
      } else {
        widgetContainer.style.removeProperty('display');
      }
    }

    if (shouldHide === smartsuppHidden) return;

    smartsuppHidden = shouldHide;
    window.smartsupp(shouldHide ? 'chat:hide' : 'chat:show');
  };

  const handleSmartsuppScroll = () => {
    if (!smartsuppHiddenForScroll) {
      smartsuppHiddenForScroll = true;
      syncSmartsuppVisibility();
    }

    window.clearTimeout(smartsuppScrollEndTimer);
    smartsuppScrollEndTimer = window.setTimeout(() => {
      smartsuppHiddenForScroll = false;
      syncSmartsuppVisibility();
    }, SMARTSUPP_SCROLL_REVEAL_DELAY);
  };

  const requestSmartsuppVisibilitySync = () => {
    if (smartsuppVisibilityFrame) return;

    smartsuppVisibilityFrame = window.requestAnimationFrame(() => {
      smartsuppVisibilityFrame = undefined;
      syncSmartsuppVisibility();
    });
  };

  const observeSmartsuppOverlay = (overlay, observer) => {
    if (observedSmartsuppOverlays.has(overlay)) return;

    observedSmartsuppOverlays.add(overlay);
    observer.observe(overlay, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal', 'role'],
    });
  };

  const initializeSmartsuppOverlayVisibility = () => {
    const overlayObserver = new MutationObserver(requestSmartsuppVisibilitySync);
    const observeOverlaysWithin = (root) => {
      if (root.matches && root.matches(SMARTSUPP_BLOCKING_OVERLAY_SELECTOR)) {
        observeSmartsuppOverlay(root, overlayObserver);

        if (root.matches('[role="dialog"][aria-modal="true"]') && root.parentElement) {
          observeSmartsuppOverlay(root.parentElement, overlayObserver);
        }
      }

      if (root.querySelectorAll) {
        root
          .querySelectorAll(SMARTSUPP_BLOCKING_OVERLAY_SELECTOR)
          .forEach((overlay) => {
            observeSmartsuppOverlay(overlay, overlayObserver);

            if (overlay.matches('[role="dialog"][aria-modal="true"]') && overlay.parentElement) {
              observeSmartsuppOverlay(overlay.parentElement, overlayObserver);
            }
          });
      }
    };

    observeOverlaysWithin(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => observeOverlaysWithin(node));
      });
      requestSmartsuppVisibilitySync();
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', handleSmartsuppScroll, { passive: true });
    syncSmartsuppVisibility();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSmartsuppOverlayVisibility, { once: true });
  } else {
    initializeSmartsuppOverlayVisibility();
  }

  const CONTENTSQUARE_SCRIPT_SRC = 'https://t.contentsquare.net/uxa/77d2cd12ac452.js';
  const CONTENTSQUARE_CONSENT_CATEGORY = 'C0002';
  const SMARTSUPP_CONSENT_CATEGORY = 'C0001';
  const CONTENTSQUARE_CONSENT_MAX_ATTEMPTS = 40;
  const CONTENTSQUARE_CONSENT_RETRY_DELAY = 250;
  const PANDECTES_CONSENT_STABILITY_DELAY = 500;
  const PANDECTES_CATEGORY_PREFERENCE_BITS = {
    C0001: 1,
    C0002: 2,
    C0003: 4,
  };
  const pandectesAllowConsentCandidates = {};
  let smartsuppLoadRequested = false;

  const loadContentsquare = () => {
    if (window._contentsquareLoaded) return;
    window._contentsquareLoaded = true;

    const cs = document.createElement('script');
    cs.src = CONTENTSQUARE_SCRIPT_SRC;
    cs.defer = true;
    document.head.appendChild(cs);
  };

  const hasExplicitShopifyConsent = (consentType) => {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy || !customerPrivacy.currentVisitorConsent) {
      return false;
    }

    const visitorConsent = customerPrivacy.currentVisitorConsent();

    return visitorConsent && (visitorConsent[consentType] === 'yes' || visitorConsent[consentType] === true);
  };

  const shopifyConsentEventAllows = (event, consentType) => {
    const detail = event && event.detail;
    const explicitAllowedFields =
      consentType === 'analytics'
        ? ['analyticsAllowed', 'analyticsProcessingAllowed']
        : ['preferencesAllowed', 'preferencesProcessingAllowed'];

    return Boolean(
      detail &&
        (explicitAllowedFields.some((field) => detail[field] === true) ||
          detail[consentType] === true ||
          detail[consentType] === 'yes')
    );
  };

  const getCookie = (name) => {
    const cookie = document.cookie.split('; ').find((item) => item.indexOf(`${name}=`) === 0);

    return cookie ? cookie.substring(name.length + 1) : '';
  };

  const parsePandectesConsentCookie = (cookie) => {
    try {
      return JSON.parse(window.atob(decodeURIComponent(cookie)));
    } catch (error) {
      return null;
    }
  };

  const resetPandectesAllowCandidate = (category) => {
    delete pandectesAllowConsentCandidates[category];
  };

  const isPandectesBannerVisible = () => {
    const banner = document.querySelector('pandectes-cmp[data-active-instance="true"]');

    if (!banner) return false;

    const styles = window.getComputedStyle(banner);

    if (styles.display === 'none' || styles.visibility === 'hidden') return false;
    if (!banner.shadowRoot) return true;

    return Boolean(
      banner.shadowRoot.querySelector('button.allow, button.deny') ||
        /Przyjmij|Odrzuć|Accept|Reject/i.test(banner.shadowRoot.textContent || '')
    );
  };

  const pandectesConsentAllowsCategory = (category) => {
    const cookie = getCookie('_pandectes_gdpr');
    const consent = cookie ? parsePandectesConsentCookie(cookie) : null;

    if (isPandectesBannerVisible()) {
      resetPandectesAllowCandidate(category);
      return false;
    }

    if (!consent || consent.method !== 'explicit') {
      resetPandectesAllowCandidate(category);
      return false;
    }

    if (consent.status === 'deny') {
      resetPandectesAllowCandidate(category);
      return false;
    }

    const preferenceBit = PANDECTES_CATEGORY_PREFERENCE_BITS[category];
    const allowsCategory =
      consent.status === 'allow' ||
      (typeof preferenceBit === 'number' &&
        typeof consent.preferences === 'number' &&
        (consent.preferences & preferenceBit) === 0);

    if (!allowsCategory) {
      resetPandectesAllowCandidate(category);
      return false;
    }

    const now = Date.now();
    const allowCandidate = pandectesAllowConsentCandidates[category];

    if (!allowCandidate || allowCandidate.cookie !== cookie) {
      pandectesAllowConsentCandidates[category] = {
        cookie,
        firstSeenAt: now,
      };
      return false;
    }

    return now - allowCandidate.firstSeenAt >= PANDECTES_CONSENT_STABILITY_DELAY;
  };

  const isPandectesConsentUpdate = (entry) => {
    return Boolean(entry && entry.event === 'Pandectes_Consent_Update');
  };

  const pandectesConsentUpdateAllowsCategory = (entry, category) => {
    return Boolean(
      isPandectesConsentUpdate(entry) &&
        entry.pandectes_status === 'allow' &&
        entry.pandectes_categories &&
        entry.pandectes_categories[category] === 'allow'
    );
  };

  const pandectesConsentUpdateAllowsManagedCategory = (entry) => {
    return (
      pandectesConsentUpdateAllowsCategory(entry, CONTENTSQUARE_CONSENT_CATEGORY) ||
      pandectesConsentUpdateAllowsCategory(entry, SMARTSUPP_CONSENT_CATEGORY)
    );
  };

  const scheduleConsentCheck = () => {
    [100, 700, 1500].forEach((delay) => {
      window.setTimeout(() => {
        maybeLoadConsentManagedScripts();
      }, delay);
    });
  };

  const maybeLoadContentsquare = (event) => {
    if (
      hasExplicitShopifyConsent('analytics') ||
      shopifyConsentEventAllows(event, 'analytics') ||
      pandectesConsentAllowsCategory(CONTENTSQUARE_CONSENT_CATEGORY)
    ) {
      loadContentsquare();
    }
  };

  const maybeLoadSmartsupp = (event) => {
    if (!smartsuppLoadRequested) return;

    if (
      hasExplicitShopifyConsent('preferences') ||
      shopifyConsentEventAllows(event, 'preferences') ||
      pandectesConsentAllowsCategory(SMARTSUPP_CONSENT_CATEGORY)
    ) {
      loadSmartsupp();
    }
  };

  const maybeLoadConsentManagedScripts = (event) => {
    maybeLoadContentsquare(event);
    maybeLoadSmartsupp(event);
  };

  const handlePandectesConsentUpdate = () => {
    scheduleConsentCheck();
  };

  const startConsentPolling = () => {
    if (window._thirdPartyConsentPollingStarted) return;

    window._thirdPartyConsentPollingStarted = true;
    let attempts = 0;

    const poll = () => {
      if (window._contentsquareLoaded && window._smartsuppLoaded) return;

      maybeLoadConsentManagedScripts();

      if (attempts >= CONTENTSQUARE_CONSENT_MAX_ATTEMPTS) return;

      attempts += 1;
      window.setTimeout(poll, CONTENTSQUARE_CONSENT_RETRY_DELAY);
    };

    window.setTimeout(poll, CONTENTSQUARE_CONSENT_RETRY_DELAY);
  };

  const watchPandectesDataLayer = () => {
    window.dataLayer = window.dataLayer || [];

    if (window.dataLayer._thirdPartyConsentHooked) return;

    const originalPush = window.dataLayer.push;

    window.dataLayer.push = function () {
      const pushedItems = Array.prototype.slice.call(arguments);
      const result = originalPush.apply(window.dataLayer, pushedItems);

      if (pushedItems.some(pandectesConsentUpdateAllowsManagedCategory)) {
        handlePandectesConsentUpdate();
      }

      return result;
    };

    window.dataLayer._thirdPartyConsentHooked = true;

    if (window.dataLayer.some(pandectesConsentUpdateAllowsManagedCategory)) {
      handlePandectesConsentUpdate();
    }
  };

  const initializeConsentManagedScripts = (attempt = 0) => {
    if (!window._thirdPartyConsentListenersBound) {
      window._thirdPartyConsentListenersBound = true;
      document.addEventListener('visitorConsentCollected', maybeLoadConsentManagedScripts);
    }

    watchPandectesDataLayer();
    maybeLoadConsentManagedScripts();
    startConsentPolling();

    if (!window.Shopify || !window.Shopify.loadFeatures) {
      if (attempt < CONTENTSQUARE_CONSENT_MAX_ATTEMPTS) {
        window.setTimeout(() => {
          initializeConsentManagedScripts(attempt + 1);
        }, CONTENTSQUARE_CONSENT_RETRY_DELAY);
      }

      return;
    }

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;

      maybeLoadConsentManagedScripts();
    });
  };

  const loadSmartsupp = () => {
    if (window._smartsuppLoaded) return;
    window._smartsuppLoaded = true;

    const c = document.createElement('script');
    c.type = 'text/javascript';
    c.charset = 'utf-8';
    c.async = true;
    c.src = 'https://www.smartsuppchat.com/loader.js?';
    document.head.appendChild(c);
  };

  const requestSmartsuppLoad = () => {
    smartsuppLoadRequested = true;
    maybeLoadSmartsupp();
  };

  initializeConsentManagedScripts();

  const timer = setTimeout(requestSmartsuppLoad, 2000);
  ['mouseover', 'keydown', 'touchstart', 'scroll'].forEach((eventName) => {
    window.addEventListener(
      eventName,
      () => {
        clearTimeout(timer);
        requestSmartsuppLoad();
      },
      { once: true, passive: true }
    );
  });
})();
